// extracted by mini-css-extract-plugin
export default {"container":"ZonePeers_container__5iNBb","periodContainer":"ZonePeers_periodContainer__g79eV","table":"ZonePeers_table__co64L"};